import BaseTable from 'components/Tables/BaseTable';
import { alertError } from 'ducks/alerts';
import { actions as actionsRawMaterials } from 'ducks/rawMaterials';
import { actions as actionsSupplierRegister } from 'ducks/supplierRegister';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
    getImmutableStoreById, mixtureSubstancesByMixture, shipmentsByRawMaterial,
    substancesWithRegistersByShipment
} from 'selectors/generic';
import shipmentRegisterColumns from 'utils/tables/columns/inventory/shipmentRegister';
import { validator as shipmentRegisterValidator } from 'utils/tables/validators/shipmentRegisters';
import { currentUser } from 'selectors/currentUser';

const Component = props => {
    const {
        idAccount, parentLoading, rawMaterials, rawMaterial, shipmentId,
        shipmentsOfRawMaterial, substancesByMixture, substancesWithRegisters, tableOptions
    } = props;
    const {
        alertError, createSupplierRegister, fetchRawMaterial, updateSupplierRegister
    } = props;
    let shipmentDetails = [];
    let shipment = undefined;
    const tableRef = React.useRef(null);

    // TODO Removable after Data on DB is equalized
    const initValuesForColumns = {};

    const [loading, setLoading] = useState(loading);

    if (shipmentId) {
        // The shipment is still looked for among this raw material's own, so a
        // shipment id belonging to another one still finds nothing.
        shipment = (shipmentsOfRawMaterial[rawMaterial.id] || []).find(s => s.id === shipmentId);
        if (shipment) {
            shipmentDetails = (substancesWithRegisters[shipment.id] || []).map(sourcedSubstance => {
                const interSubstance = (substancesByMixture[rawMaterial.id] || [])
                    .find(s => s.id === sourcedSubstance['id']);
                const rawMaterialData = rawMaterials[sourcedSubstance['substance_id']];
                return {
                    update: sourcedSubstance['supplier_registers'].length !== 0,
                    type: rawMaterialData.type,
                    name: rawMaterialData.name,
                    ec: rawMaterialData.ec,
                    cas: rawMaterialData.cas,
                    ...initValuesForColumns,
                    ...sourcedSubstance['supplier_registers'][0],
                    mixture_substance_id: interSubstance['id'],
                    percentage: interSubstance['percentage'],
                    raw_material_supplier_id: shipment.id,
                    account_id: idAccount
                };
            });
        }
    }

    return (
        <BaseTable
            ref={tableRef}
            title={
                shipmentId && shipment ?
                    `${shipment.code} - ${shipment.trade_name}` :
                    'Seleccione um fornecimento de matéria prima acima...'
            }
            isLoading={loading || parentLoading}
            columns={shipmentRegisterColumns}
            data={shipmentDetails}
            onRowClick={() => null}
            paging={false}
            halfSize={true}
            editable={{
                onRowUpdate: (newData, oldData) => {
                    if (newData.update) {
                        const srValidation = shipmentRegisterValidator(newData, undefined);
                        if (srValidation.error) {
                            alertError(srValidation.error);
                            return Promise.reject();
                        }
                        setLoading(true);
                        return updateSupplierRegister(newData.id, { ...newData })
                            .then(() => fetchRawMaterial(rawMaterial.id))
                            .catch(e => alert(e))
                            .finally(() => setLoading(false));
                    } else {
                        const srValidation = shipmentRegisterValidator(newData, undefined);
                        if (srValidation.error) {
                            alertError(srValidation.error);
                            return Promise.reject();
                        }
                        setLoading(true);
                        return createSupplierRegister({ ...newData })
                            .then(() => fetchRawMaterial(rawMaterial.id))
                            .catch(e => alert(e))
                            .finally(() => setLoading(false));
                    }
                }
            }}
        />
    );
};

const makeMapStateToProps = () => {
    const rawMaterials = getImmutableStoreById('rawMaterials');
    const mapStateToProps = (state, props) => ({
        rawMaterials: rawMaterials(state),
        idAccount: currentUser(state).account_id,
        shipmentsOfRawMaterial: shipmentsByRawMaterial(state),
        substancesByMixture: mixtureSubstancesByMixture(state),
        substancesWithRegisters: substancesWithRegistersByShipment(state)
    });
    return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
    alertError: error => dispatch(alertError(error)),
    updateSupplierRegister: (id, data) => dispatch(actionsSupplierRegister.updatePromise(id, data)),
    createSupplierRegister: (data) => dispatch(actionsSupplierRegister.createPromise(data)),
    fetchRawMaterial: id => dispatch(actionsRawMaterials.fetchOne(id))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
